var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderColorButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26499 14.648C3.35998 14.6604 3.45686 14.6668 3.55523 14.6668H3.83301V14.1113H3.55523C3.48095 14.1113 3.40807 14.1065 3.33685 14.0972L3.26499 14.648Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 14.6668H12.4441C12.5425 14.6668 12.6394 14.6604 12.7344 14.648L12.6625 14.0972C12.5913 14.1065 12.5184 14.1113 12.4441 14.1113H12.1663V14.6668Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2948 14.4982C13.4754 14.4233 13.6441 14.3252 13.797 14.2077L13.4585 13.7672C13.3436 13.8555 13.2171 13.929 13.082 13.985L13.2948 14.4982Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2072 13.7975C14.3247 13.6445 14.4228 13.4759 14.4977 13.2952L13.9845 13.0824C13.9285 13.2176 13.855 13.3441 13.7667 13.4589L14.2072 13.7975Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 3.8335V3.55572C14.6663 3.45735 14.66 3.36047 14.6476 3.26548L14.0967 3.33733C14.106 3.40856 14.1108 3.48144 14.1108 3.55572V3.8335H14.6663Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4977 2.70508C14.4228 2.52442 14.3247 2.35578 14.2072 2.20286L13.7667 2.54138C13.855 2.65624 13.9285 2.78269 13.9845 2.91789L14.4977 2.70508Z",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.797 1.79261C13.6441 1.6751 13.4754 1.57704 13.2948 1.50212L13.082 2.0153C13.2171 2.07136 13.3436 2.14485 13.4585 2.23312L13.797 1.79261Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55523 1.3335H3.83301V1.88905H3.55523C3.48095 1.88905 3.40807 1.89388 3.33685 1.90317L3.26499 1.35228C3.35998 1.33989 3.45686 1.3335 3.55523 1.3335Z",
    fill: "#585858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70459 1.50212C2.52393 1.57704 2.35529 1.6751 2.20238 1.79261L2.54089 2.23312C2.65575 2.14485 2.7822 2.07136 2.9174 2.0153L2.70459 1.50212Z",
    fill: "#585858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79212 2.20286C1.67461 2.35578 1.57655 2.52442 1.50163 2.70508L2.01481 2.91789C2.07088 2.78269 2.14436 2.65624 2.23263 2.54138L1.79212 2.20286Z",
    fill: "#585858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 12.1668V12.4446C1.33301 12.543 1.3394 12.6399 1.35179 12.7348L1.90268 12.663C1.89339 12.5918 1.88856 12.5189 1.88856 12.4446V12.1668H1.33301Z",
    fill: "#585858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50163 13.2952C1.57655 13.4759 1.67461 13.6445 1.79212 13.7975L2.23263 13.4589C2.14436 13.3441 2.07087 13.2176 2.01481 13.0824L1.50163 13.2952Z",
    fill: "#585858"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70459 14.4982C2.52393 14.4233 2.35529 14.3252 2.20238 14.2077L2.54089 13.7672C2.65575 13.8555 2.7822 13.929 2.9174 13.985L2.70459 14.4982Z",
    fill: "#585858"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 11.6113V11.0557H1.88856V11.6113H1.33301Z",
    fill: "#585858"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 10.5002V9.94461H1.88856V10.5002H1.33301Z",
    fill: "#585858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 9.38905V8.8335H1.88856V9.38905H1.33301Z",
    fill: "#585858"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 8.27794V7.72239H1.88856V8.27794H1.33301Z",
    fill: "#585858"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 7.16683V6.61127H1.88856V7.16683H1.33301Z",
    fill: "#585858"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 6.05572V5.50016H1.88856V6.05572H1.33301Z",
    fill: "#585858"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 4.94461V4.38905H1.88856V4.94461H1.33301Z",
    fill: "#585858"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 3.8335V3.55572C1.33301 3.45735 1.3394 3.36047 1.35179 3.26548L1.90268 3.33733C1.89339 3.40856 1.88856 3.48144 1.88856 3.55572V3.8335H1.33301Z",
    fill: "#585858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38856 1.3335H4.94412V1.88905H4.38856V1.3335Z",
    fill: "#585858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49967 1.3335H6.05523V1.88905H5.49967V1.3335Z",
    fill: "#585858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61079 1.3335H7.16634V1.88905H6.61079V1.3335Z",
    fill: "#585858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7219 1.3335H8.27745V1.88905H7.7219V1.3335Z",
    fill: "#585858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 1.3335H9.38856V1.88905H8.83301V1.3335Z",
    fill: "#585858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94412 1.3335H10.4997V1.88905H9.94412V1.3335Z",
    fill: "#585858"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 1.3335H11.6108V1.88905H11.0552V1.3335Z",
    fill: "#585858"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 1.3335H12.4441C12.5425 1.3335 12.6394 1.33989 12.7344 1.35228L12.6625 1.90317C12.5913 1.89388 12.5184 1.88905 12.4441 1.88905H12.1663V1.3335Z",
    fill: "#585858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 4.38905V4.94461H14.1108V4.38905H14.6663Z",
    fill: "#585858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 5.50016V6.05572H14.1108V5.50016H14.6663Z",
    fill: "#585858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 6.61127V7.16683H14.1108V6.61127H14.6663Z",
    fill: "#585858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.72239V8.27794H14.1108V7.72239H14.6663Z",
    fill: "#585858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.8335V9.38905H14.1108V8.8335H14.6663Z",
    fill: "#585858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 9.94461V10.5002H14.1108V9.94461H14.6663Z",
    fill: "#585858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 11.0557V11.6113H14.1108V11.0557H14.6663Z",
    fill: "#585858"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 12.1668V12.4446C14.6663 12.543 14.66 12.6399 14.6476 12.7349L14.0967 12.663C14.106 12.5918 14.1108 12.5189 14.1108 12.4446V12.1668H14.6663Z",
    fill: "#585858"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6108 14.6668H11.0552V14.1113H11.6108V14.6668Z",
    fill: "#585858"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 14.6668H9.94412V14.1113H10.4997V14.6668Z",
    fill: "#585858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38856 14.6668H8.83301V14.1113H9.38856V14.6668Z",
    fill: "#585858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27745 14.6668H7.7219V14.1113H8.27745V14.6668Z",
    fill: "#585858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16634 14.6668H6.61079V14.1113H7.16634V14.6668Z",
    fill: "#585858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05523 14.6668H5.49967V14.1113H6.05523V14.6668Z",
    fill: "#585858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94412 14.6668H4.38856V14.1113H4.94412V14.6668Z",
    fill: "#585858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53445 9.27368L3.87258 11.2515H2.99967L5.33061 4.66683H6.18433L8.51526 11.2515H7.63277L6.9709 9.27368H4.53445ZM6.74548 8.59351L5.76706 5.66056H5.74308L4.75987 8.59351H6.74548Z",
    fill: "#585858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2083 10.6196H12.1843C11.9301 11.0296 11.4697 11.3335 10.7263 11.3335C9.75267 11.3335 9.08121 10.7257 9.08121 9.79466C9.08121 8.90706 9.69512 8.34749 10.851 8.34266H12.1795V7.8265C12.1795 7.1608 11.7958 6.79418 11.1148 6.79418C10.4673 6.79418 10.098 7.12703 10.05 7.63354H9.27306C9.32581 6.74594 9.92533 6.09954 11.1436 6.09954C12.2179 6.09954 12.9997 6.68806 12.9997 7.75414V11.2515H12.2083V10.6196ZM9.92533 9.76572C9.92533 10.3639 10.4193 10.6437 10.9469 10.6437C11.652 10.6437 12.1795 10.1999 12.1795 9.56794V8.97942H10.9133C10.2227 8.97942 9.92533 9.30745 9.92533 9.76572Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderColorButton);
export default __webpack_public_path__ + "static/media/borderColorButton.310f70467285a38a49f3de6a150ff815.svg";
export { ForwardRef as ReactComponent };